//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { getFullMonthName } from 'src/onboarding/helpers/getFullMonthName';

function Page() {
  const thoughts = useStore((state) => state.thoughts);
  const setThoughts = useStore((state) => state.setThoughts);
  const idealWeight = useStore((state) => state.idealWeight);
  const when = useStore((state) => state.when);

  const { onNext, onPrev, currentIndex } = useNav();

  const getOrdinalSuffix = (day: number): string => {
    const lastDigit = day % 10;
    const lastTwoDigits = day % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
      return 'th';
    }

    switch (lastDigit) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };
  const formatDate = (date): string => {
    const day = parseInt(date.day, 10);
    const monthName = getFullMonthName(date.month);
    const suffix = getOrdinalSuffix(day);

    return `${monthName} ${day}${suffix}, ${date.year}`;
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>
          {t('onboarding.thoughts.title', {
            weight: idealWeight.value + ' ' + idealWeight.type,
            date: formatDate(when),
          })}
        </Title>
        <Text size='m' medium className={'description'} style={{ padding: 0 }}>
          {t('onboarding.thoughts.subTitle')}
        </Text>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={thoughts}
          onChange={(value) => {
            setThoughts(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'thoughts',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'I can totally do it!'}>{t('onboarding.thoughts.options.doIt')}</Option>
          <Option value={"I'm uncertain, but willing to try"}>
            {t('onboarding.thoughts.options.try')}
          </Option>
          <Option value={"I'm still unsure"}>{t('onboarding.thoughts.options.unsure')}</Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
